import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useButtonManager } from "~/managers/use-button-manager";
import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useButtonStore } from "~/stores/use-button-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import ButtonForm from "./button-form";

export default function ButtonDialog() {
  const { t } = useTranslation("common");
  const {
    buttonDialogOpen,
    selectedButton,
    setButtonDialogOpen,
    setSelectedButton,
  } = useButtonStore();

  const { deleteButton } = useButtonManager();

  const { checkUnsavedChanges, setUnsavedChanges } = useUnsavedChanges();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedButton(undefined);
    }
    setButtonDialogOpen(open);
  };

  const handleDeleteButton = async () => {
    if (!selectedButton?.id) return;
    const result = await deleteButton(selectedButton.id);
    if (result === true) {
      setUnsavedChanges({
        isDirty: false,
      });
      handleDialog(false, true);
    }
  };
  return (
    <Dialog open={buttonDialogOpen} onOpenChange={handleDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("Button.dialog_title", { index: selectedButton?.position })}
          </DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4 max-w-lg w-full">
          {selectedButton && (
            <ButtonForm
              button={selectedButton}
              onClose={(force) => handleDialog(false, force)}
            />
          )}
        </ScrollArea>
        <DialogFooter className="flex gap-2">
          {selectedButton?.id && (
            <Button
              className="text-red-500 w-full"
              onClick={handleDeleteButton}
              variant="ghost"
            >
              {t("delete")}
            </Button>
          )}
          <Button
            variant="success"
            className="w-full"
            form="button-form"
            type="submit"
          >
            {t("update")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
